/* eslint-disable import/prefer-default-export */
import { useState, useCallback } from 'react';

export const useMobileHeader = () => {
  /**
   * useMobileHeader State
   */

  const [mobileMenuActiveItem, setMobileMenuActiveItem] = useState<string | null>(null);

  /**
   * useMobileHeader Handlers
   */

  const toggleMobileMenuActiveItem = useCallback(
    (id: string) => {
      if (id === mobileMenuActiveItem) return setMobileMenuActiveItem(null);

      return setMobileMenuActiveItem(id);
    },
    [mobileMenuActiveItem],
  );

  /**
   * useMobileHeader Return
   */

  return {
    mobileMenuActiveItem,
    toggleMobileMenuActiveItem,
  };
};
